var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.sections},_vm._l((_vm.getPartners),function(partner){return _c('Section',{key:partner.id,attrs:{"partner":partner}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }